module.exports = __webpack_public_path__ + "img/very-helpful--unscreen.5eb409a8.gif";